/*=========================================================================================
  File Name: module-licenseinfo-actions.js
  Description: LicenseInfo Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import LicenseInfoAPI from '@/api/LicenseInfoAPI.js';
import DateUtil from '@/utils/dateUtil';

export default {
	/**
	 * lấy thông tin license
	 */
	getConfigInbot: async function(context, payload) {
		let fn = async function(payload) {
			let res = await httpClient.getAsync(
				{
					url: LicenseInfoAPI.getAPIUrl() + `/config`,
					params: payload
				},
				false,
				false
			);
			if (res && res.Success) {
				context.commit('updateConfig', res.Data);
				return res.Data;
			}
			// Trả kết quả
			return null;
		};
		//Nếu chưa có thông tin cấu hình hoặc phiên bản không khớp thì gọi lại API
		if (
			Object.keys(context.state.Config).length == 0 ||
			context.state.Config.Version !== window.__env.ConfigApplication.appVersion
		) {
			return await fn(payload);
		} else {
			return context.state.Config;
		}
	},
	/**
	 * lấy thông tin license
	 */
	getLicenseByTaxCode: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: LicenseInfoAPI.getAPIUrl() + `/${localStorage.getItem('SubscriberCode')}`,
				params: payload
			},
			true,
			false
		);
		if (res && res.Success) {
			context.commit('updateLicenseInfo', res.Data);
		}
		// Trả kết quả
		return res.Data;
	},
	/**
	 * lấy thông tin license
	 */
	updateInvoiceCount: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: LicenseInfoAPI.getAPIUrl() + `/invoicecount/${localStorage.getItem('SubscriberCode')}`,
				params: payload
			},
			false,
			false
		);
		return res;
	},
	/**
	 * Cập nhật gia hạn, mua thêm, nâng cấp để sau
	 */
	laterUpdateLicenseAsync: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url:
					LicenseInfoAPI.getAPIUrl() + '/later-update-license' + `/${localStorage.getItem('SubscriberCode')}`,
				params: payload
			},
			false,
			false
		);
		return res.Data;
	},
	/**
	 * Kiểm tra mã số thuế có license chính thức hay k
	 */
	checkExistTaxCode: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: LicenseInfoAPI.getAPIUrl() + '/existtaxcode' + `/${payload.TaxCode}`,
				params: payload
			},
			false,
			false
		);
		return res;
	}
};
